import React, { useEffect } from "react";
import UserTable from "./components/UserTable";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import {
  selectAllUsers,
  selectChecked,
  selectLoadingAllUsers,
  selectSelectedUsers,
  toggleAll,
  toggleUserSelection,
} from "feature/admin/slice";
import { fetchAllUsers } from "feature/admin/actions";
import useCheckbox from "./hooks/useCheckbox";
import { User } from "feature/admin/types";

const AllUsers = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector(selectAllUsers);
  const loadingUsers = useAppSelector(selectLoadingAllUsers);
  const selectedUsers = useAppSelector(selectSelectedUsers);
  const checked = useAppSelector(selectChecked);

  const checkbox = useCheckbox<User>({
    items: users,
    selectedItems: selectedUsers,
    checked,
  });

  const toggleAllHandler = () => {
    dispatch(toggleAll());
  };

  useEffect(() => {
    dispatch(fetchAllUsers());
  }, []);

  const toggleUserSelectionHandler = (user: User, checked: boolean) => {
    dispatch(toggleUserSelection({ user, checked }));
  };

  return (
    <UserTable
      title={"All Users"}
      users={users}
      isLoading={loadingUsers}
      checkbox={checkbox}
      toggleAllHandler={toggleAllHandler}
      selectedUsers={selectedUsers}
      toggleUserSelectionHandler={toggleUserSelectionHandler}
      checked={checked}
      showOrganization
    />
  );
};

export default AllUsers;
